// extracted by mini-css-extract-plugin
export default {"reactPlayerClass":"instructionalVideo_reactPlayerClass__3xdkq"};